import cx from 'classnames';
import Loader from '../Loader/Loader';
import styles from './InfiniteScroll.module.scss';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import { SkeletonLoaderContainer, SKELETON_LOADER_TYPE } from '../../skeletonLoaderUI/SkeletonLoaderUI';
import { isCuratorPage } from '../../helpers/urlHelper';

const InfiniteScroll = ({
  loading,
  loadingType = SKELETON_LOADER_TYPE.THUMBNAIL_CARD,
  containerClassName,
  id,
  dataLength,
  next,
  hasMore,
  className,
  children,
  Component = 'div',
  skeletonContainerClass,
  showMenu = true,
  redirect = true
}) => {
  const hasData = dataLength !== 0;
  const [sentryRef] = useInfiniteScroll({
    loading,
    hasNextPage: hasMore,
    onLoadMore: next,
    // disabled: !!error,
    rootMargin: '0px 0px 400px 0px',
  });

  let extraSmallLoaderCard;
  if (!showMenu && !redirect) {
    extraSmallLoaderCard = true;
  }


  const loader = hasData ? (
    (!isCuratorPage() && loadingType)
    ?
    <SkeletonLoaderContainer 
      ref={sentryRef}
      type={loadingType}
      loading={true}
      extraSmallLoaderCard={extraSmallLoaderCard}
    />
    :
    <Loader
      ref={sentryRef}
      loading={true}
      position="relative"
      backdrop={false}
      className={styles.loader}
    />
  ) : null;
  
  if (!isCuratorPage() && loadingType) {
    return (
      <SkeletonLoaderContainer
        type={loadingType}
        extraSmallLoaderCard={extraSmallLoaderCard}
        loading={hasData ? false : loading}
        id={id}
        className={skeletonContainerClass}>
        {Component ? <Component className={className}>{children}</Component> : children}
        {(loading || hasMore) && loader}
      </SkeletonLoaderContainer>
    );
  }

  // const loader = hasData ? (
  //   <Loader
  //     ref={sentryRef}
  //     loading={true}
  //     position="relative"
  //     backdrop={false}
  //     className={styles.loader}
  //   />
  // ) : null;

  return (
    <Loader
      loading={hasData ? false : loading}
      position="relative"
      backdrop={false}
      className={cx(styles.container, containerClassName)}
      id={id}>
      {Component ? <Component className={className}>{children}</Component> : children}
      {(loading || hasMore) && loader}
    </Loader>
  );

};

export default InfiniteScroll;
